// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"532":"ef632cbcc9682858e4c3","691":"5b52917d4e6a59d52677"}[chunkId] + ".js";
};